export const SET_THEME_VARIANT = 'SET_THEME_VARIANT';
export const SET_IS_THEME_LOADED = 'SET_IS_THEME_LOADED';
export const SELECTED_THEME_VARIANT_KEY = 'selected-paragon-theme-variant';
